export default "__VITE_ASSET__e07cd6f4__"